const Svg = () => (
  <svg
    width="136"
    height="34"
    viewBox="0 0 136 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M118.27 31.92C122.89 28.78 125.93 23.48 125.93 17.48V0H119.83V17.48C119.83 23.74 114.74 28.83 108.48 28.83C102.22 28.83 97.13 23.74 97.13 17.48V0H91.03V17.48C91.03 23.48 94.07 28.77 98.69 31.92H85.42V0H79.32V13.24H56.61V0H50.51V31.92H37.24C41.86 28.78 44.9 23.48 44.9 17.48C44.91 7.86 37.08 0.03 27.45 0.03C17.82 0.03 10 7.86 10 17.48C10 23.48 13.04 28.77 17.66 31.92H0V33.25H135.93V31.92H118.26H118.27ZM16.1 17.48C16.1 11.22 21.19 6.13 27.45 6.13C33.71 6.13 38.8 11.22 38.8 17.48C38.8 23.74 33.71 28.83 27.45 28.83C21.19 28.83 16.1 23.74 16.1 17.48ZM56.61 19.34H79.32V31.92H56.61V19.34Z"
      fill="#EBDCD5"
    />
  </svg>
);
export default Svg;
